module.exports = __webpack_public_path__ + "img/main.c1507f14.svg";